require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./projects-archive-limewire-org.json") })
        }
      }, "path---projects-archive-limewire-org");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---projects-archive-limewire-org!./.cache/json/projects-archive-limewire-org.json
// module id = 362
// module chunks = 231608221292675